/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import { Grid } from '@material-ui/core'
import MaterialTable from 'material-table'
import EditIcon from '@mui/icons-material/Edit'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { ModalQuestionary } from './ModalQuestionary'
import ROUTES from '../../../routers/routes'
import { useHistory } from 'react-router-dom'
import { getMonitoringAndEvaluationQuestionnaireAnswers } from '../../../services/MonitoreoYEvaluacion/get'
import { useAuthentication } from '../../../context/authenticationContext'
import {
  Box,
  Button,
  FormControl,
  Modal,
  TextField,
  Typography,
} from '@mui/material'
import RestorePageIcon from '@mui/icons-material/RestorePage'
import { ModalDetalleForm } from './ModalDetalleFormulario'

export const TableQuestionary = () => {
  const history = useHistory()
  const { IdIFIToken } = useAuthentication()
  const [open, setOpen] = useState(false)
  const [data, setData] = useState([])
  const [ObservationForm, setObservationForm] = useState(null)
  const [openObservations, setOpenObservations] = useState(false)
  const [loading, setLoading] = useState(true)
  const [openHistory, setOpenHistory] = useState(false)
  const [IdFormulario, setIdFormulario] = useState(null)

  const [idQuestionnaireAnswer, setIdQuestionnaireAnswer] = useState('')

  const getAnswer = async () => {
    try {
      const response = await getMonitoringAndEvaluationQuestionnaireAnswers(
        IdIFIToken,
      )
      if (response.Success) {
        setData(response.Data)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  useEffect(() => {
    getAnswer()
  }, [])

  const columns = [
    {
      title: 'Fecha',
      field: 'PresentationDate',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Registro Tributario',
      field: 'TaxRegistration',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'MIPYME',
      field: 'MiPyme',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Proyecto',
      field: 'SubprojectName',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Medida de Adaptación',
      field: 'AdaptationAction',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Estado',
      field: 'StatusName',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
  ]
  const handleQuestionnaire = (IdQuestionnaireAnswer) => {
    history.push(ROUTES.CUESTIONARIOMONITOREOYEVALUACION.pathname, {
      IdQuestionnaireAnswer: IdQuestionnaireAnswer,
    })
  }

  const handleCloseObservation = () => {
    setOpenObservations(false)
    setObservationForm(null)
    setIdQuestionnaireAnswer('')
  }

  return (
    <>
      <Grid
        container
        style={{
          width: '100%',
          height: 'auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            height: 'auto',
            width: '96%',
            backgroundColor: '#fff',
            borderRadius: '4px',
          }}
        >
          <div className="App">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <MaterialTable
                  columns={columns}
                  data={data}
                  isLoading={loading}
                  actions={[
                    (rowData) =>
                      rowData.StatusName !== 'En revisión' &&
                      rowData.StatusName !== 'Cancelado' &&
                      rowData.StatusName !== 'Aprobado' &&
                      rowData.StatusName !== 'Cerrado'
                        ? {
                            icon: () => (
                              <EditIcon style={{ color: '#0d53ad' }} />
                            ),
                            tooltip: 'Editar',

                            onClick: (event, rowData) => {
                              if (rowData.Observations === null) {
                                handleQuestionnaire(rowData.IdForm)
                              } else {
                                setOpenObservations(true)
                                setObservationForm(rowData.Observations)
                                setIdQuestionnaireAnswer(rowData.IdForm)
                              }
                            },
                          }
                        : null,
                    (rowData) =>
                      rowData.StatusName !== 'En revisión' &&
                      rowData.StatusName !== 'Cancelado' &&
                      rowData.StatusName !== 'Aprobado' &&
                      rowData.StatusName !== 'Cerrado'
                        ? {
                            icon: () => <VisibilityIcon />,
                            tooltip: 'Ver',
                            disabled: true,
                            onClick: (event, rowData) => {},
                          }
                        : null,
                    (rowData) =>
                      rowData.StatusName === 'En revisión' ||
                      rowData.StatusName === 'Cancelado' ||
                      rowData.StatusName === 'Aprobado' ||
                      rowData.StatusName === 'Cerrado'
                        ? {
                            icon: () => <EditIcon />,
                            tooltip: 'Editar',

                            disabled: true,
                          }
                        : null,
                    (rowData) =>
                      rowData.StatusName === 'En revisión' ||
                      rowData.StatusName === 'Cancelado' ||
                      rowData.StatusName === 'Aprobado' ||
                      rowData.StatusName === 'Cerrado'
                        ? {
                            icon: () => <VisibilityIcon color="success" />,
                            tooltip: 'Ver',

                            onClick: (event, rowData) => {
                              handleQuestionnaire(rowData.IdForm)
                            },
                          }
                        : null,

                    // {
                    //   icon: () => <RestorePageIcon color="primary" />,
                    //   tooltip: 'Historial Formulario',
                    //   onClick: (event, rowData) => {
                    //     setIdFormulario(rowData.IdForm)
                    //     setOpenHistory(true)
                    //   },
                    // },
                  ]}
                  onSelectionChange={(selectedRows) =>
                    console.log(selectedRows)
                  }
                  options={{
                    sorting: true,
                    search: true,
                    searchFieldAlignment: 'right',
                    searchAutoFocus: true,
                    searchFieldVariant: 'standard',
                    filtering: true,
                    paging: true,
                    pageSizeOptions: [2, 5, 10, 20],
                    pageSize: 5,
                    paginationType: 'stepped',
                    showFirstLastPageButtons: false,
                    paginationPosition: 'bottom',
                    exportAllData: true,
                    exportFileName: 'TableData',
                    // addRowPosition: 'first',
                    actionsColumnIndex: -1,
                    selection: false,
                    showSelectAllCheckbox: false,
                    showTextRowsSelected: false,
                    selectionProps: (rowData) => ({
                      disabled: rowData.age == null,
                      // color:"primary"
                    }),
                    // grouping: true,

                    rowStyle: (data, index) =>
                      index % 2 === 0 ? { background: '#f5f5f5' } : null,
                    headerStyle: { background: '#014b96', color: '#fff' },
                  }}
                  localization={{
                    body: {
                      editRow: {
                        deleteText: '¿Está seguro de eliminar el registro?',
                      },
                      emptyDataSourceMessage: 'No hay registros a desplegar',
                    },
                    header: {
                      actions: 'Acciones',
                    },
                    toolbar: {
                      searchPlaceholder: 'Buscar',
                    },
                  }}
                  title=" "
                />
              </Grid>
            </Grid>
          </div>
        </div>
        <Modal
          open={openObservations}
          onClose={handleCloseObservation}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="modalPYME">
            <Grid className="modalTitle">
              <Typography
                id="modal-modal-title"
                style={{ fontWeight: '900' }}
                variant="h6"
                component="h2"
              >
                Observaciones
              </Typography>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                }}
              >
                <Grid
                  container
                  spacing={1}
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                  }}
                >
                  <Grid item xs={12} sm={12} md={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} md={12}>
                        <label className="responsiveLabel">
                          Correciones por realizar en tu formulario.
                        </label>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl fullWidth>
                          <textarea
                            id="Observation"
                            name="Observation"
                            placeholder="Observaciones"
                            customInput={TextField}
                            inputProps={{ maxLength: 250 }}
                            value={ObservationForm}
                            disabled
                          ></textarea>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid className="buttonsPYME">
                  <Button
                    className="cancelButton"
                    onClick={() => handleCloseObservation()}
                  >
                    Cancelar
                  </Button>
                  <Button
                    className="confirmButton"
                    onClick={() => handleQuestionnaire(idQuestionnaireAnswer)}
                  >
                    Editar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <ModalDetalleForm
          open={openHistory}
          setOpen={setOpenHistory}
          IdFormulario={IdFormulario}
          setIdFormulario={setIdFormulario}
        />

        <ModalQuestionary open={open} setOpen={setOpen} />
      </Grid>
    </>
  )
}
